import Alert from '../Alert/Alert';

function ErrorMessage(props) {
    return (
        <>
            {props.error.map((data, key) => {
                const message = data.message ? data.message : data;
                return (
                    <Alert key={key} variant="danger" body={message} />
                );
            })}
        </>
    );
}

export default ErrorMessage;